// Chrome / Safari page translation swaps the app's text nodes for translated <font> copies. React still holds the
// originals, so its next removeChild / insertBefore on them threw "not a child of this node" and the whole page
// fell to the crash screen (crews on translated phones, right after login). Let those two calls tolerate a
// translated page instead: removing a node that's already gone is a no-op, inserting before one appends.
import { reportClientError } from '@/lib/clientErrorReporter';

let noted = false;
function note(op) {
  if (noted) return;
  noted = true;
  reportClientError('translate_guard', `Page translation: skipped a ${op} on a translated node (no crash)`);
}

export function installTranslateGuard() {
  if (typeof Node !== 'function' || !Node.prototype || Node.prototype.__strataTranslateGuard) return;
  const { removeChild, insertBefore } = Node.prototype;
  Node.prototype.removeChild = function guardedRemoveChild(child) {
    if (child && child.parentNode !== this) {
      note('removeChild');
      return child;
    }
    return removeChild.apply(this, arguments);
  };
  Node.prototype.insertBefore = function guardedInsertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      note('insertBefore');
      return insertBefore.call(this, newNode, null);
    }
    return insertBefore.apply(this, arguments);
  };
  Node.prototype.__strataTranslateGuard = true;
}
